/* eslint-disable no-redeclare */
class KtznEventSubscriptionError extends Error {
  /** Error type */
  type: KtznEventSubscriptionError.Type;

  constructor(type: KtznEventSubscriptionError.Type = KtznEventSubscriptionError.Type.general, ...params: any[]) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, KtznEventSubscriptionError);
    }

    this.name = "KtznEventSubscriptionError";
    // Custom debugging information
    this.type = type;
  }
}

namespace KtznEventSubscriptionError {
  export enum Type {
    general = "General error",
    alreadyConnected = "Already connected",
    noSubscribeName = "No subscribeName",
    subscriptionExists = "Subscription already exists",
    getCogntioTokenFailed = "Getting a new cognito token failed",
    sendFailed = "Sending the event failed",
    subscribeFailed = "Subscribing failed",
    subscribeToTenantFailed = "Subscribing to tenant failed",
    subscribeToUserFailed = "Subscribing to user failed",
    subscribeToConversationFailed = "Subscribing to conversation failed",
    subscribeToConversationsFailed = "Subscribing to multiple conversations failed",
    reSubscribeFailed = "ReSubscribing failed",
    unSubscribeFailed = "Unsubscribing failed",
    unsubscribeFromAllFailed = "Unsubscribe from multiple subscriptions failed",
    cacheSubscriptionExists = "Subscription already exists in cache",
    cacheSubscriptionDontExists = "Subscription doesn't exists in cache",
  }
}

export default KtznEventSubscriptionError;
